// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Sales = [
  {
    title: 'Ledger Followup',
    path: '/dashboard/manage/sales/ledger_followups',
    icon: icon('company', 'png'),
    ShortName: 'SalesFollowupPanel',
  },
  {
    title: 'Order Followup',
    path: '/dashboard/manage/sales/order_followups',
    icon: icon('company', 'png'),
    ShortName: 'OrderFollwUps',
  },
  {
    title: 'Pre Booking',
    path: '/dashboard/manage/sales/pre_booking',
    icon: icon('company', 'png'),
    ShortName: 'PreBooking',
  },
  {
    title: 'Unfinished Registration',
    path: '/dashboard/manage/signup_crm',
    icon: icon('company', 'png'),
    ShortName: 'SignupCRM',
  },
];

export default Sales;
